// extracted by css-extract-rspack-plugin
export default {"modalFooter":"DeleteReport__modalFooter--LZZ9e","footerButton":"DeleteReport__footerButton--xQ0a1","warning":"DeleteReport__warning--HlvM1"};